var QuerKeysEnum;
(function (QuerKeysEnum) {
    QuerKeysEnum["FirstBySpaceIds"] = "spaceIds";
    QuerKeysEnum["ThenByRoleIds"] = "spaceRoleIds";
    QuerKeysEnum["ThenByChannelIds"] = "channelIds";
})(QuerKeysEnum || (QuerKeysEnum = {}));
// when adding a query, make sure each is unique for the given purpose
// recommended pattern: [queryName, ...queryArgs], where queryArgs goes from generic to specific
// example: ['roles', spaceId, roleId]
export const blockchainKeys = {
    spaceAndChannel: (spaceId, channelId) => [
        'spacesAndChannels',
        QuerKeysEnum.FirstBySpaceIds,
        spaceId,
        QuerKeysEnum.ThenByChannelIds,
        channelId,
    ],
    hasPermission: (args) => ['hasPermission', args],
    roles: (spaceId) => ['roles', QuerKeysEnum.FirstBySpaceIds, spaceId],
    roleDetails: (spaceId, roleId) => [
        'rolesDetails',
        QuerKeysEnum.FirstBySpaceIds,
        spaceId,
        QuerKeysEnum.ThenByRoleIds,
        roleId,
    ],
    channelPermissionOverrides: (spaceId, roleId, channelId) => [
        'channelPermissionOverrides',
        QuerKeysEnum.FirstBySpaceIds,
        spaceId,
        QuerKeysEnum.ThenByRoleIds,
        roleId,
        channelId,
    ],
    spaceInfo: (spaceId) => ['spaceInfo', QuerKeysEnum.FirstBySpaceIds, spaceId],
    channelInfo: (channelId, updatedAtKey) => [
        'channelInfo',
        'channelId',
        channelId,
        'updatedAtKey',
        updatedAtKey,
    ],
    // optional roledIds allow for passing only spaceId to get all multipleRoleDetails queries for this space
    multipleRoleDetails: (spaceId, roleIds) => {
        const queryKey = [
            'multipleRolesDetails',
            QuerKeysEnum.FirstBySpaceIds,
            spaceId,
            QuerKeysEnum.ThenByRoleIds,
        ];
        if (roleIds) {
            queryKey.push(roleIds);
        }
        return queryKey;
    },
    entitledChannels: (spaceId) => ['syncEntitledChannels', spaceId],
    membershipInfo: (spaceId) => ['membershipInfo', spaceId],
    linkedWallets: (walletAddress) => ['linkedWallets', walletAddress],
    rootKeyFromLinkedWallet: (walletAddress) => ['rootKeyFromLinkedWallet', walletAddress],
    hasMemberNft: (spaceId) => ['hasMemberNft', spaceId ?? 'waitingForSpaceId'],
    walletAddressIsBanned: (userId, spaceId) => [
        'walletAddressIsBanned',
        userId,
        spaceId,
    ],
    bannedWalletAddresses: (spaceId) => ['bannedWalletAddresses', spaceId],
    pricingModules: (chainId) => [
        'pricingModules',
        { chainId: chainId ?? 'waitingForChainId' },
    ],
    supportedXChainIds: () => ['supportedXChainIds'],
    prepaidSupply: (spaceId) => [
        'prepaidSupply',
        spaceId ?? 'waitingForSpaceId',
    ],
    minimumMembershipPrice: () => ['minimumMembershipPrice'],
    membershipMintLimit: () => ['membershipMintLimit'],
    membershipFreeAllocation: (spaceId) => [
        'membershipFreeAllocation',
        spaceId ?? 'waitingForSpaceId',
    ],
    membershipFee: () => ['membershipFee'],
    riverPoints: (chainId, walletAddress) => [
        'riverPoints',
        chainId ?? 'waitingForChainId',
        walletAddress,
    ],
    spaceTotalTips: (spaceId) => ['spaceTotalTips', spaceId],
    tokenIdOfOwner: (spaceId, ownerAddress) => [
        'tokenIdOfOwner',
        spaceId ?? 'waitingForSpaceId',
        ownerAddress,
    ],
    protocolFee: (spaceId) => ['protocolFee', spaceId ?? 'waitingForSpaceId'],
    spaceReviews: (spaceId) => ['spaceReviews', spaceId],
};
//# sourceMappingURL=query-keys.js.map